"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _v = _interopRequireDefault(require("uuid/v4"));
var _googleTagManagerTransformer = _interopRequireDefault(require("./helpers/googleTagManagerTransformer"));
var _constants = require("./constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); } /* eslint-disable no-console */
window.riDigitalGTM = window.riDigitalGTM || [];
var ifInitialised = function ifInitialised(fn) {
  if (!window.riDigitalData) {
    console.error('The riDigitalData does not exist. Make sure you initialise the riDigitalData correctly by adding it to the window object');
    return null;
  }
  return fn();
};
var add = function add(eventName, newData) {
  return ifInitialised(function () {
    if (!window.riDigitalData) {
      console.error('The riDigitalData does not exist. Make sure you initialise the riDigitalData correctly by adding it to the window object');
      return null;
    }
    if (typeof eventName !== 'string' || eventName === '') {
      console.error("You must pass an eventName string to riDigitalData.add");
      return null;
    }
    if (newData === null || newData === undefined) {
      console.error("You cannot pass null or undefined to riDigitalData.add");
      return null;
    }
    if (Array.isArray(newData)) {
      console.error("You must pass an object to riDigitalData.add but you passed an array");
      return null;
    }
    if (_typeof(newData) !== 'object') {
      console.error("You must pass an object to riDigitalData.add but you passed a ".concat(_typeof(newData)));
      return null;
    }
    if (newData.name !== undefined) {
      console.error('You passed new data with a "name" field but it is reserved');
      return null;
    }
    var transformedEventName = eventName;
    var isType = !!_constants.typeKeys[eventName];
    if (isType) {
      transformedEventName = _constants.typeKeys[eventName].keyName || eventName;
    }
    var guid = (0, _v["default"])();
    var logObject = {
      name: transformedEventName,
      guid: guid
    };
    window.riDigitalData._events.push(_objectSpread(_objectSpread({}, logObject), newData));
    var event = new CustomEvent("riDigitalData.".concat(transformedEventName), {
      detail: logObject
    });
    window.dispatchEvent(event);
    var gtmEvent = (0, _googleTagManagerTransformer["default"])(eventName, newData, guid);
    window.riDigitalGTM.push(gtmEvent);
    return window.riDigitalData;
  });
};
var getLog = function getLog() {
  return ifInitialised(function () {
    return window.riDigitalData._events.map(function (_ref) {
      var guid = _ref.guid,
        name = _ref.name;
      return {
        guid: guid,
        name: name
      };
    });
  });
};
var read = function read(guid, fields) {
  return ifInitialised(function () {
    var _events = window.riDigitalData._events;
    var indexOfTarget = -1;
    _events.some(function (event, index) {
      if (event.guid === guid) {
        indexOfTarget = index;
        return true;
      }
      return false;
    });
    if (indexOfTarget === -1) {
      console.warn('An event with that guid was not found on the data layer');
      return {};
    }
    var dataAtTimeOfEvent = _events.slice(0, indexOfTarget + 1);
    var result = dataAtTimeOfEvent.reduceRight(function (accumulator, event) {
      fields.forEach(function (field) {
        if (accumulator[field] === undefined) {
          accumulator[field] = event[field];
        }
      });
      return accumulator;
    }, {});
    fields.forEach(function (field) {
      if (result[field] === undefined) {
        console.warn("riDigitalData does not have data found for the requested field: \"".concat(field, "\""));
        result[field] = null;
      }
    });
    result.name = _events[indexOfTarget].name;
    return result;
  });
};
var dataLayerFactory = function dataLayerFactory() {
  return {
    __proto__: {
      add: add,
      getLog: getLog,
      read: read,
      _events: []
    }
  };
};
var _default = exports["default"] = dataLayerFactory;